import React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { FieldRenderProps } from "react-final-form";
import { IconButton, InputAdornment } from "@material-ui/core";
import { TextFieldProps } from "@material-ui/core/TextField";

import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

import withFieldControl from "../FieldControl";

import { TextField } from "./styles";

type Props = {
  required?: boolean;
} & TextFieldProps &
  FieldRenderProps<any>;

@observer
class PasswordFieldControl extends React.Component<Props> {
  @observable showPassword: boolean = false;

  toggleShowPassword = () => {
    this.showPassword = !this.showPassword;
  };

  render() {
    const {
      input,
      type,
      label,
      meta,
      error,
      autoFocus,
      autoComplete,
      required,
      ...restProps
    } = this.props;

    return (
      <TextField
        {...input}
        type={this.showPassword ? "text" : "password"}
        label={label}
        helperText={(meta.touched && meta.error) || error}
        error={Boolean((meta.touched && meta.error) || error)}
        autoFocus={autoFocus}
        autoComplete={autoComplete}
        required={required}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={this.toggleShowPassword}
                edge="end"
                size="small"
              >
                {this.showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        {...restProps}
      />
    );
  }
}

export default withFieldControl(PasswordFieldControl);
